module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/logo.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/nav')
      }
    }
  }), _vm._v(" "), (!_vm.showSearchTextBox) ? _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "item",
    class: _vm.navIndex === 0 ? 'current' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openInNewPage('/goods?primaryId=163&secondaryId=250')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Fabric')))]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: _vm.navIndex === 1 ? 'current' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openInNewPage('/designlist?parentId=4&id=125')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Style Library')))]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: _vm.navIndex === 2 ? 'current' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openInNewPage('/commonChanel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Public Showroom')))]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: _vm.navIndex === 3 ? 'current' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openInNewPage('/privateChanel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Private Showroom')))])]) : _vm._e(), _vm._v(" "), (_vm.showSearchTextBox) ? _c('div', {
    staticClass: "search-text-box"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": _vm.closeSearchTextBox
    }
  }), _vm._v(" "), _c('el-autocomplete', {
    ref: "searchInput",
    staticClass: "key-word",
    attrs: {
      "placeholder": "Search Community",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchEnter($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeSearchTextBox($event)
      }]
    },
    model: {
      value: (_vm.searchKeyWord),
      callback: function($$v) {
        _vm.searchKeyWord = $$v
      },
      expression: "searchKeyWord"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "button-search",
    on: {
      "click": _vm.handleSearchText
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tool tool-search-text",
    on: {
      "click": _vm.openSearchTextBox
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Search",
      "visible-arrow": false,
      "placement": "bottom",
      "popper-class": "header-tool-tips"
    }
  }, [_c('i', {
    staticClass: "icon"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "tool tool-search-image"
  }, [_c('el-upload', {
    attrs: {
      "before-upload": _vm.handleBeforeUpload,
      "list-type": "picture",
      "show-file-list": false,
      "action": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Search by image",
      "visible-arrow": false,
      "placement": "bottom",
      "popper-class": "header-tool-tips"
    }
  }, [_c('i', {
    staticClass: "icon"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tool tool-search-advanced",
    on: {
      "click": function($event) {
        return _vm.showAdvanceSearch()
      }
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Advanced Search",
      "visible-arrow": false,
      "placement": "bottom",
      "popper-class": "header-tool-tips"
    }
  }, [_c('i', {
    staticClass: "icon"
  })])], 1), _vm._v(" "), _c('advance-search', {
    attrs: {
      "dialogVisible": _vm.showSearchAdvancedDialog
    },
    on: {
      "closeDialog": _vm.closeAdvanceSearch,
      "openLink": _vm.openInSelfPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user",
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        _vm.showUserMenu = true
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.showUserMenu = false
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": _vm.avatarUrl,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.showUserMenu) ? _c('div', {
    staticClass: "user-menu-wrapper"
  }, [_c('div', {
    staticClass: "user-menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-icon"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": _vm.avatarUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(this.userInfo.info.customerName))]), _vm._v(" "), _c('div', {
    staticClass: "vip"
  }, [_vm._v("VIP")])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/favorite?menuType=fabric')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Favorites')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myDesign')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Design')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myOrder')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Order')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myGarmentSample')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Development')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/myFabric')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('My Fabric')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/wesAiCreate')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('W&S AI')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/VRChanel')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('VR Showroom')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/privateChanel')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Private Showroom')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/history')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Browsing History')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/userinfo')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Personal Center')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/setting')
      }
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Security Setting')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.openInNewPage('/help')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Help')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-sep"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.handleLoginOut
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.$t('Log Out')))])])])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.showCrumb) ? _c('div', {
    attrs: {
      "id": "crumb"
    }
  }, [(_vm.searchCrumb.mode) ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('Fabric')))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")]), _vm._v(" "), (_vm.searchCrumb.mode === 'keyword') ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('Search')))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.searchCrumb.keyword))])] : (_vm.searchCrumb.mode === 'image') ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('Image Search')))])] : (_vm.searchCrumb.mode === 'advanced') ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('Advanced Search')))])] : _vm._e()] : [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('Fabric')))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")]), _vm._v(" "), (_vm.crumb.level2.name != null) ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t(_vm.crumb.level2.name)))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")])] : _vm._e(), _vm._v(" "), (_vm.crumb.level3.name != null) ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t(_vm.crumb.level3.name)))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")])] : _vm._e(), _vm._v(" "), (_vm.crumb.level4.name != null) ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t(_vm.crumb.level4.name)))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")])] : _vm._e(), _vm._v(" "), (_vm.crumb.level5.name != null) ? [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t(_vm.crumb.level5.name)))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v(">")])] : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    attrs: {
      "id": "category"
    }
  }, [_c('div', {
    staticClass: "primary-category"
  }, _vm._l((_vm.categories), function(primary, indexPrimary) {
    return _c('div', {
      staticClass: "item",
      class: primary.entity.id === _vm.highlightCategoryId.primary ? 'highlight' : '',
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          return _vm.handleMouseEnterPrimaryCategory(indexPrimary, primary.entity.id)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          return _vm.handleMouseLeavePrimaryCategory(indexPrimary, primary.entity.id)
        },
        "click": function($event) {
          return _vm.handleClickPrimaryCategory(indexPrimary, primary.entity.id)
        }
      }
    }, [_c('div', {
      staticClass: "name",
      class: primary.entity.id === _vm.currentCategoryId.primary ? 'current' : ''
    }, [_vm._v(_vm._s(_vm.$t(primary.entity.alias)))]), _vm._v(" "), _c('div', {
      staticClass: "secondary-category"
    }, [_c('div', {
      staticClass: "inner"
    }, _vm._l((primary.children), function(secondary, indexSecondary) {
      return _c('div', {
        staticClass: "item",
        class: [secondary.entity.id === _vm.clickedCategoryId.secondary ? 'highlight' : '',
          secondary.entity.id === _vm.currentCategoryId.secondary ? 'current' : ''
        ],
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleClickSecondaryCategory(indexPrimary, indexSecondary, primary.entity.id, secondary.entity.id)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.$t(secondary.entity.alias)) + "\n            ")])
    }), 0), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showTertiaryCategory),
        expression: "showTertiaryCategory"
      }],
      staticClass: "tertiary-category"
    }, _vm._l((_vm.tertiaryCategories), function(tertiary, index) {
      return _c('div', {
        staticClass: "item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleClickTertiaryCategory(primary.entity.id, tertiary.entity.parentId, tertiary.entity.id)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.$t(tertiary.entity.alias)) + "\n            ")])
    }), 0)])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-favorite.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-design.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-module.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-history.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-user.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-setting.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-question.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": require("@/assets/layout/icon/icon-logout.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9d0f294","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/fabricHeader.vue
// module id = 474
// module chunks = 63